import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const GHLOAuthCallback = () => {
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const code = searchParams.get("code");

        if (!code) {
            return;
        }

        fetch(`${process.env.REACT_APP_API_BASE_URL}/OAuth/callback/gohighlevel?code=${code}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Failed with status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                console.log("OAuth callback success:", data);
            })
            .catch((error) => {
                console.error("OAuth callback error:", error);
            });
    }, [searchParams]);

    return <div>Processing OAuth callback...</div>;
};

export default GHLOAuthCallback;
